import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function StorySection() {
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-10 px-5 bg-white" data-id="element-175">
      <div className="max-w-2xl mx-auto" data-id="element-176">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={{
        visible: {
          transition: {
            staggerChildren: 0.15
          }
        }
      }} className="space-y-5 text-lg md:text-xl text-charcoal leading-relaxed" data-id="element-177">
          <motion.p variants={fadeUp} className="font-medium text-xl md:text-2xl" data-id="element-178">
            You wake up tired. Not just physically…
          </motion.p>

          <motion.p variants={fadeUp} data-id="element-179">But mentally… Emotionally…</motion.p>

          <motion.p variants={fadeUp} data-id="element-180">
            Like your body never actually shut off.
          </motion.p>

          <motion.p variants={fadeUp} data-id="element-181">
            And before your day even begins… It's already there.
          </motion.p>

          <motion.div variants={fadeUp} className="pl-6 border-l-2 border-terracotta-light text-charcoal-light italic space-y-4 py-2" data-id="element-182">
            <p data-id="element-183">That tightness in your chest.</p>
            <p data-id="element-184">That low, constant pressure in your head.</p>
            <p data-id="element-185">That feeling like you're already behind…</p>
          </motion.div>

          <motion.p variants={fadeUp} data-id="element-186">Before you've done anything.</motion.p>

          <motion.p variants={fadeUp} data-id="element-187">
            And at some point… You've probably asked yourself:
          </motion.p>

          <motion.p variants={fadeUp} className="font-serif text-2xl md:text-3xl text-center text-terracotta mt-8" data-id="element-188">
            "Why is this so hard for me?"
          </motion.p>
        </motion.div>
      </div>
    </section>;
}